import { FixedComponentsRateChartRequest, FixedComponentsRateChartResponseModel } from "@gtpl/shared-models/masters"
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages"
import { Controller, Post, Body } from "@nestjs/common"
import { ApiTags } from "@nestjs/swagger"
import { FixedComponentsRateChartService } from "./fixed-components-rate-chart-service"

@ApiTags('fixed-components-rate-chart')
@Controller('fixed-components-rate-chart')
export class FixedComponentsRateChartController{
    constructor(
        private fixedComponentsRateChartService:FixedComponentsRateChartService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}
    @Post('/createFixedComponentsRateChart')
    async createFixedComponentsRateChart(@Body() req:FixedComponentsRateChartRequest,updated:boolean):Promise<FixedComponentsRateChartResponseModel>{
        try{
            return await this.fixedComponentsRateChartService.createFixedComponentsRateChart(req,updated)
        }catch(err){
            return this.applicationExceptionhandler.returnException(FixedComponentsRateChartResponseModel,err)
        }
    }
    @Post('/getAllFixedComponentsRateChartInfo')
    async getAllFixedComponentsRateChartInfo():Promise<FixedComponentsRateChartResponseModel>{
        try{
            return await this.fixedComponentsRateChartService.getAllFixedComponentsRateChartInfo()
        }catch(err){
            return this.applicationExceptionhandler.returnException(FixedComponentsRateChartResponseModel,err)
        }
    }
    @Post('/updateFixedComponentsRateChart')
    async updateFixedComponentsRateChart(@Body() req:FixedComponentsRateChartRequest,isUpdate:boolean=true): Promise<FixedComponentsRateChartResponseModel> {
        try {
         return await this.fixedComponentsRateChartService.createFixedComponentsRateChart(req,isUpdate);
       } catch (error) {
            return this.applicationExceptionhandler.returnException(FixedComponentsRateChartResponseModel, error);
       }
     }
}